import { FormControlProps } from '../lib/type';
import { cn } from '../lib/utils';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, useFormContext } from './form';
import { NumericFormat, NumericFormatProps } from "react-number-format";
import { Input } from './input';
import { VariantProps } from 'class-variance-authority';
import { textFieldVariants } from './text-field';
import { JSX } from 'react';
export function NumericFormatField({
  name,
  className,
  label,
  numericFormatProps,
  variant,
  description,
  placeholder
}: FormControlProps &
  React.ComponentProps<"input"> &VariantProps<typeof textFieldVariants> & {
    numericFormatProps: NumericFormatProps;
  }):JSX.Element  {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <div className={textFieldVariants({ variant })}>
            {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
            <FormControl>
              <NumericFormat
                {...numericFormatProps}
                value={field.value}
                placeholder={placeholder}
                onValueChange={(value) => {
                  field.onChange(value.value);
                }}
                className={cn("h-12 bg-white", label && "px-3 py-3")}
                customInput={Input}
              />
            </FormControl>
          </div>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
